import { Document, Font, Image, Page, StyleSheet, Text, View, pdf, Link } from '@react-pdf/renderer'
import { useCallback, useEffect, useRef, useState } from 'react'
import { HiArrowDownTray } from 'react-icons/hi2'
import { Spinner } from 'react-bootstrap'
import EuclidBold from '../../Styles/pdfFonts/euclidBold.ttf'
import EuclidItalic from '../../Styles/pdfFonts/euclidItalic.ttf'
import EuclidRegular from '../../Styles/pdfFonts/euclidRegular.ttf'

const PdfDocument = ({ data }) => (
	<Document>
		<Page style={[styles.page, { padding: 0 }]}>
			<View style={{ width: '100%', height: '100%', padding: 0, margin: 0 }}>
				<Image src='https://assets.mydna.company/pdf-assessment/cover-updated.jpg' cache style={{ height: '110%' }} />
				<View style={styles.roundedBox}>
					<Text style={styles.headerText}>REPORTE</Text>
					<Text style={styles.title}>
						Reporte de{'\n'}
						Nómina
					</Text>
					<Text style={styles.name}>{data.name}</Text>
					<Text style={styles.description}>
						Este reporte es un producto de MyDNA. MyDNA Assessment es una solución de liderazgo para todos para promover, atraer y retener talentos.
					</Text>
					<Text style={styles.footer}>2022 | C Todos los derechos reservados.</Text>
				</View>
			</View>
		</Page>

		<Page style={styles.page}>
			<View style={[styles.roundedTextBox, { marginTop: 20 }]}>
				<Text style={styles.text}>Introducción</Text>
			</View>

			<View style={{ position: 'absolute', marginTop: 80 }}>
				<Text style={[styles.defaultText, { marginBottom: 14 }]}>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque finibus tellus at ante venenatis, vel tempor turpis accumsan. Duis
					congue elit risus, a scelerisque purus eleifend at. Morbi lobortis nisi id tempor commodo. Quisque iaculis ultricies dui, in dignissim
					purus. Mauris at egestas turpis, eget tempor nisi. Donec mauris orci, aliquet id varius eu, feugiat at ligula. Cras ut maximus lectus, ut
					fermentum enim. Sed eget tellus vitae arcu lobortis ornare. Vivamus metus leo, maximus vitae diam sed, condimentum mattis velit. Etiam quis
					velit interdum, mollis tortor non, accumsan quam. Duis ut tellus ac eros mattis auctor. Sed id lectus nulla.
				</Text>
				<Text style={[styles.defaultText, { marginBottom: 14 }]}>
					Nullam elit est, condimentum at tortor a, rhoncus imperdiet ligula. In ac felis neque. Sed sed purus facilisis, dictum nunc ut, efficitur
					nulla. Integer ultricies rutrum nunc eget dapibus. Phasellus ac neque ipsum. Maecenas dui velit, sollicitudin vitae metus in, vulputate
					sollicitudin diam. Donec vestibulum enim et neque aliquam egestas.
				</Text>
				<Text style={[styles.defaultText, { marginBottom: 14 }]}>
					Mauris eu aliquam odio, eu mattis neque. Vestibulum facilisis neque a interdum vestibulum. Phasellus ut est et massa ullamcorper egestas non
					vel elit. Pellentesque sodales a turpis eu iaculis. In nulla orci, mollis malesuada blandit in, hendrerit sit amet arcu. Suspendisse
					potenti. Pellentesque fringilla consectetur augue, eget varius quam commodo eu. Nullam ultrices vulputate convallis. Mauris hendrerit, quam
					a maximus vulputate, urna erat lacinia risus, in consequat turpis neque eget ipsum. Donec viverra egestas dolor, ac mollis risus tempus sed.
					Etiam ac turpis ac mi molestie vulputate. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Donec
					ac nunc ac dolor volutpat luctus.
				</Text>
			</View>

			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

				<View style={styles.logoContainer}>
					<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
					<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}></Text>
				</View>
			</View>
		</Page>

		<Page style={styles.page}>
			<View style={[styles.roundedTextBox, { marginTop: 20 }]}>
				<Text style={styles.text}>Nómina</Text>
			</View>

			<View style={{ position: 'absolute', marginTop: 80 }}>
				<View style={{ marginBottom: 8 }}>
					<Text style={styles.defaultText}>{`REMUNERACIONES MES DE: ${data.month} del ${data.year}`}</Text>
					<Text style={styles.defaultText}>
						{data.legalName} / {`RUT: ${data.companyDocument}`} / {data.address}
					</Text>
				</View>

				<View style={{ marginBottom: 4 }}>
					<Text style={styles.defaultText}>Nome: {data.name}</Text>
					<Text style={styles.defaultText}>Cargo: {data.jobPosition}</Text>
					<Text style={styles.defaultText}>
						RUT: {data.employeeDocument} - {data.digit}
					</Text>
				</View>

				<View
					style={{
						flexDirection: 'row',
						justifyContent: 'space-between',
						marginHorizontal: 26,
						marginBottom: 10,
					}}
				>
					{/* Coluna Haberes */}
					<View style={{ width: '48%' }}>
						<Text
							style={[
								styles.headerText,
								{
									backgroundColor: '#e5e7eb',
									color: 'black',
									padding: 3,
									fontSize: 12,
									marginBottom: 5,
									textAlign: 'center',
									marginLeft: 0,
								},
							]}
						>
							Haberes
						</Text>
						<Text style={styles.defaultText}>{`Días Trabajados: ${data.daysWorked30}`}</Text>
						<Text style={styles.defaultText}>{`Sueldo Base: $ ${data.baseSalary}`}</Text>
						<Text style={styles.defaultText}>{`Gratificación Legal: $ ${data.gratuity}`}</Text>
						<Text style={styles.defaultText}>{`Bonus (verificar): $ ${2000}`}</Text>
						<Text style={styles.defaultText}>{`Comisiones (verificar): $ ${200}`}</Text>
						{data.schoolEarnings != null && <Text style={styles.defaultText}>{`Haber Colegio: $ ${data.schoolEarnings}`}</Text>}
						{data.teacherHours != null && <Text style={styles.defaultText}>{`Horas Profesor: $ ${data.teacherHours}`}</Text>}
						{data.overtime != null && <Text style={styles.defaultText}>{`Hora Extraordinaria: $ ${data.overtime}`}</Text>}
						{data.sundayHours != null && <Text style={styles.defaultText}>{`Domingos y Festivos: ${data.sundayHours}`}</Text>}
						{data.sundayValue != null && <Text style={styles.defaultText}>{`Domingos y Festivos: $ ${data.sundayValue}`}</Text>}
						<Text style={styles.defaultText}>{`Total Imponible: $ ${data.totalTaxable}`}</Text>
						{data.numberOfDependents != null && <Text style={styles.defaultText}>{`Cargas Familiares: ${data.numberOfDependents}`}</Text>}
						{data.dependentsBenefit != null && <Text style={styles.defaultText}>{`Cargas Familiares: $ ${data.dependentsBenefit}`}</Text>}
						{data.retroactiveDependentsBenefit != null && (
							<Text style={styles.defaultText}>{`Cargas Retroactivas: $ ${data.retroactiveDependentsBenefit}`}</Text>
						)}
						<Text style={styles.defaultText}>{`Asignación Colación: $ ${data.mealBenefit}`}</Text>
						<Text style={styles.defaultText}>{`Asignación Movilización: $ ${data.transportBenefit}`}</Text>
						{data.otherBenefits != null && <Text style={styles.defaultText}>{`Otros: $ ${data.otherBenefits}`}</Text>}
					</View>

					{/* Coluna Descuentos */}
					<View style={{ width: '48%' }}>
						<Text
							style={[
								styles.headerText,
								{
									backgroundColor: '#e5e7eb',
									color: 'black',
									padding: 3,
									fontSize: 12,
									marginBottom: 5,
									textAlign: 'center',
									marginLeft: 0,
								},
							]}
						>
							Descuentos
						</Text>
						<Text style={styles.defaultText}>{`AFP: ${data.pensionPlan}`}</Text>
						<Text style={styles.defaultText}>{`Cotización AFP: $ ${data.pensionContribution}`}</Text>
						{data.voluntaryPensionContribution != null && (
							<Text style={styles.defaultText}>{`AFP (cuenta 2): ${data.voluntaryPensionContribution}`}</Text>
						)}
						<Text style={styles.defaultText}>{`Isapre: ${data.healthPlan}`}</Text>
						<Text style={styles.defaultText}>{`7% Obligatorio: $ ${data.healthContribuition || 'undefined'}`}</Text>
						{data.unemploymentInsuranceContribution != null && (
							<Text style={styles.defaultText}>{`Cotización AFC: $ ${data.unemploymentInsuranceContribution}`}</Text>
						)}
						{data.leaveDays != null && <Text style={styles.defaultText}>{`Licencias: $ ${data.leaveDays}`}</Text>}
						{data.absenceDays != null && <Text style={styles.defaultText}>{`Faltas: ${data.absenceDays}`}</Text>}
						{data.hoursLate != null && <Text style={styles.defaultText}>{`Horas Atraso: ${data.hoursLate}`}</Text>}
						{data.delays != null && <Text style={styles.defaultText}>{`Atrasos: ${data.delays}`}</Text>}
						{data.solidarityLoan != null && <Text style={styles.defaultText}>{`Prestamo Solidario: $ ${data.solidarityLoan}`}</Text>}
						{data.advancePayment != null && <Text style={styles.defaultText}>{`Antecipos: $ ${data.advancePayment}`}</Text>}
						{data.compensationFundInsurence != null && <Text style={styles.defaultText}>{`Seguro CCAF: $ ${data.compensationFundInsurence}`}</Text>}
						{data.compensationFundLoan != null && <Text style={styles.defaultText}>{`Prestamo CCAF: $ ${data.compensationFundLoan}`}</Text>}
						{data.companyLoan != null && <Text style={styles.defaultText}>{`Prestamo CCAF: $ ${data.companyLoan}`}</Text>}
						{data.voluntaryPensionSavingsContribution != null && (
							<Text style={styles.defaultText}>{`APV vol.: $ ${data.voluntaryPensionSavingsContribution}`}</Text>
						)}
						{data.voluntaryPensionSavingsContribution2 != null && (
							<Text style={styles.defaultText}>{`APV vol. II: $ ${data.voluntaryPensionSavingsContribution2}`}</Text>
						)}
						{data.collectivePensionContribuition != null && (
							<Text style={styles.defaultText}>{`APV vol. Colectivo: $ ${data.collectivePensionContribuition}`}</Text>
						)}
						<Text style={styles.defaultText}>{`Base Tributable: $ ${data.taxableBase}`}</Text>
						<Text style={styles.defaultText}>{`Impuestos: ${data.taxes}`}</Text>
					</View>
				</View>

				{/* Totais e data */}
				<View
					style={{
						flexDirection: 'row',
						justifyContent: 'space-between',
						marginHorizontal: 26,
						marginBottom: 10,
					}}
				>
					<View style={{ width: '48%' }}>
						<Text style={[styles.defaultText, { fontWeight: 'bold' }]}>{`Total Haberes: $ ${data.totalEarnings}`}</Text>
						<Text style={styles.defaultText}>{`Fecha: ${data.fecha}`}</Text>
					</View>
					<View style={{ width: '48%' }}>
						<Text style={[styles.defaultText, { fontWeight: 'bold' }]}>{`Total Descuentos: $ ${data.totalDiscounts}`}</Text>
						<Text style={[styles.defaultText, { fontWeight: 'bold' }]}>{`Alcance Líquido: $ ${data.totalPayable}`}</Text>
					</View>
				</View>

				{/* <Text style={styles.defaultText}>Son: Dos millones, ciento treinta y cuatro mil seiscientos treinta y tres</Text> */}
			</View>

			{/* Rodapé */}
			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} />
				<View style={styles.logoContainer}>
					<Image style={styles.logo} src='https://assets.mydna.company/mydnalogo.png' />
					<Text style={styles.defaultTextContainer}></Text>
				</View>
			</View>
		</Page>
	</Document>
)

Font.register({
	family: 'Euclid Circular B',
	fonts: [
		{
			src: EuclidRegular,
			fontWeight: 'normal',
		},
		{
			src: EuclidBold,
			fontWeight: 'bold',
		},
		{
			src: EuclidItalic,
			fontStyle: 'italic',
		},
	],
})

const styles = StyleSheet.create({
	page: {
		position: 'relative',
		backgroundColor: '#FFFFFF',
		width: '100%',
		padding: 10,
	},
	backgroundImage: {
		position: 'absolute',
		width: '100%',
		height: '100%',
	},
	roundedBox: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		width: '80%',
		backgroundColor: '#7c6cec',
		borderTopRightRadius: 20,
		padding: 20,
	},
	headerText: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 12,
		marginBottom: 22,
		marginLeft: 10,
	},
	title: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'bold',
		color: '#FFFFFF',
		fontWeight: 900,
		fontSize: 42,
		marginBottom: 22,
		marginLeft: 10,
	},
	name: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 18,
		marginBottom: 22,
		marginLeft: 10,
	},
	description: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 10,
		marginBottom: 22,
		marginLeft: 10,
		lineHeight: 1.5,
	},
	defaultText: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: 'black',
		fontSize: 10,
		marginBottom: 9,
		marginHorizontal: 26,
		lineHeight: 1.5,
	},
	footer: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 10,
		marginBottom: 22,
		marginLeft: 10,
	},

	//Tag for TitlePages
	roundedTextBox: {
		position: 'absolute',
		width: 'auto',
		// maxWidth: 350,
		left: 0,
		padding: 10,
		backgroundColor: '#7c6cec',
		borderTopRightRadius: 35,
		borderBottomRightRadius: 35,
		marginBottom: 20,
	},
	text: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'bold',
		color: '#FFFFFF',
		fontSize: 18,
		marginLeft: 10,
		marginRight: 10,
		fontWeight: 700,
	},

	detailContainer: {
		position: 'absolute',
		bottom: 350,
		left: 20,
		flexDirection: 'row',
		alignItems: 'center',
	},
	blueCircle: {
		width: 10,
		height: 10,
		borderRadius: 5,
		backgroundColor: '#00AEEF',
		marginRight: 5,
	},
	whiteRectangle: {
		width: 25,
		height: 5,
		backgroundColor: '#FFFFFF',
		borderRadius: 2.5,
		marginRight: 5,
	},
	greenCircle: {
		width: 10,
		height: 10,
		borderRadius: 5,
		backgroundColor: '#00C853',
		marginRight: 5,
	},

	//ContainerDimensions
	container: {
		marginLeft: 20,
		marginRight: 20,
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: '#0078D4',
		padding: 10,
		borderRadius: 10,
	},
	iconContainer: {
		paddingLeft: 19,
		width: 20,
		height: 20,
		borderRadius: 20,
		backgroundColor: '#FFFFFF',
		justifyContent: 'center',
		alignItems: 'center',
		marginRight: 4,
	},
	textContainer: {
		display: 'flex',
	},
	defaultTextContainer: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: 'black',
		fontSize: 10,
	},

	pill: {
		margin: 2,
		padding: 4,
		backgroundColor: '#008ACD',
		color: '#fff',
		borderRadius: 20,
		fontSize: 10,
		flexBasis: 'auto',
		width: 'auto',
	},

	progressBarContainer: {
		marginLeft: 20,
		marginRight: 20,
		width: '100%',
		backgroundColor: '#E0F3FC',
		borderRadius: 12,
		height: 12,
		overflow: 'hidden',
		marginBottom: 10,
	},
	progressBarFill: {
		backgroundColor: '#008ACD',
		height: '100%',
		borderRadius: 12,
	},

	containerSpecs: {
		display: 'flex',
		flexDirection: 'row',
		border: '1px solid #E0E0E0',
		borderRadius: 8,
		marginBottom: 10,
		overflow: 'hidden',
		width: '100%',
	},
	leftBox: {
		backgroundColor: '#008ACD',
		padding: 10,
		width: '30%',
		color: 'white',
	},
	rightBox: {
		padding: 10,
		width: '70%',
	},
	listText: {
		fontSize: 10,
		marginBottom: 3,
	},

	layoutContainer: {
		padding: 10,
		border: '1px solid #E0E0E0',
		borderRadius: 8,
		width: '100%',
	},
	layoutHeader: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		backgroundColor: '#008ACD',
		padding: 10,
		color: 'white',
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
	},
	layoutTitle: {
		fontSize: 14,
		fontWeight: 'bold',
	},
	layoutPercentage: {
		fontSize: 14,
		fontWeight: 'bold',
	},
	layoutContent: {
		padding: 10,
		borderBottom: 8,
	},
	layoutRow: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: 5,
	},
	layoutColumn: {
		width: '45%',
	},
	layoutSubtitle: {
		fontSize: 12,
		fontWeight: 'bold',
		marginBottom: 5,
	},
	layoutParagraph: {
		fontSize: 10,
		marginBottom: 5,
	},
	layoutBadge: {
		backgroundColor: '#E3F2FD',
		color: '#007BFF',
		fontSize: 10,
		padding: '2px 4px',
		borderRadius: 8,
		alignSelf: 'flex-start',
	},

	circleNumber: {
		width: 16,
		height: 16,
		borderRadius: 15,
		backgroundColor: '#f1f4f9',
		justifyContent: 'center',
		alignItems: 'center',
		marginRight: 10,
	},

	footerPage: {
		position: 'absolute',
		bottom: 10,
		left: 0,
		right: 0,
		height: 50,
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingHorizontal: 30,
	},
	pageNumber: {
		fontSize: 10,
		color: '#000',
	},
	logoContainer: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	logo: {
		width: 60,
		height: 'auto',
	},

	containerOptions: {
		backgroundColor: '#f5f8fa',
		borderRadius: 10,
		padding: 10,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: 5,
		marginBottom: 20,
		marginLeft: 20,
		marginRight: 20,
	},
	option: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	circle: {
		width: 10,
		height: 10,
		borderRadius: 5,
		borderWidth: 1,
		borderColor: '#E69138',
		marginRight: 4,
	},
})

const PDFButton = ({ active, data }) => {
	const [loading, setLoading] = useState(false)

	const handleOpenPDF = async () => {
		if (!active || loading) return
		setLoading(true)

		const doc = <PdfDocument data={data} />

		const asPdf = pdf([])
		asPdf.updateContainer(doc)

		const blob = await asPdf.toBlob()
		const url = URL.createObjectURL(blob)
		window.open(url, '_blank')
		setLoading(false)
	}

	const hasLoaded = useRef(false)

	useEffect(() => {
		if (active && !hasLoaded.current) {
			hasLoaded.current = true
		}
	}, [active])

	return (
		<button
			onClick={handleOpenPDF}
			disabled={active !== true || loading}
			className='tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-3xl tw-text-center tw-flex-1 tw-cursor-pointer border-0'
		>
			{loading ? (
				<Spinner animation='border' style={{ color: '#fff', width: '22px', height: '22px' }} />
			) : (
				<div className='tw-flex tw-items-center tw-justify-center tw-gap-2'>
					Descargar Liquidación
					<HiArrowDownTray size={22} className='tw-text-white' />
				</div>
			)}
		</button>
	)
}
export default PDFButton
